export default "__VITE_ASSET__D$SNjc3H__"